<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="80" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                :label="$t('message.labelTime')"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                :label="$t('message.labelDate')"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>
          <mu-row gutter>
            <mu-col desktop="100" tablet="100" width="100">
              <mu-row gutter>
                <mu-col width="100" tablet="100" desktop="50" v-if="preference === 'cm'">
                  <mu-text-field
                    v-validate
                    data-vv-validate-on="none"
                    :data-vv-rules="'required|min_value:0|max_value:1000'"
                    data-vv-name="waist_cm"
                    data-vv-value-path="inputValue"
                    :errorText="errors.first('waist_cm')"
                    type="number"
                    label="waist cm"
                    :hintText="$t('message.placeholderText')"
                    v-model.number="reading.waist_cm"
                    :fullWidth="true"
                  />
                </mu-col>
                <mu-col width="100" tablet="100" desktop="50" v-if="preference === 'cm'">
                  <mu-text-field
                    v-validate
                    data-vv-validate-on="none"
                    :data-vv-rules="'required|min_value:0|max_value:1000'"
                    data-vv-name="hip_cm"
                    data-vv-value-path="inputValue"
                    :errorText="errors.first('hip_cm')"
                    type="number"
                    label="hip cm"
                    :hintText="$t('message.placeholderText')"
                    v-model.number="reading.hip_cm"
                    :fullWidth="true"
                  />
                </mu-col>
                <mu-col width="100" tablet="100" desktop="50" v-if="preference === 'in'">
                  <mu-text-field
                    v-validate
                    data-vv-validate-on="none"
                    :data-vv-rules="'required|min_value:0|max_value:1000'"
                    data-vv-name="waist_in"
                    data-vv-value-path="inputValue"
                    :errorText="errors.first('waist_in')"
                    type="number"
                    label="waist in"
                    :hintText="$t('message.placeholderText')"
                    v-model.number="reading.waist_in"
                    :fullWidth="true"
                  />
                </mu-col>
                <mu-col width="100" tablet="100" desktop="50" v-if="preference === 'in'">
                  <mu-text-field
                    v-validate
                    data-vv-validate-on="none"
                    :data-vv-rules="'required|min_value:0|max_value:1000'"
                    data-vv-name="hip_in"
                    data-vv-value-path="inputValue"
                    :errorText="errors.first('hip_in')"
                    type="number"
                    label="hip in"
                    :hintText="$t('message.placeholderText')"
                    v-model.number="reading.hip_in"
                    :fullWidth="true"
                  />
                </mu-col>
              </mu-row>
            </mu-col>
          </mu-row>
        </mu-col>
      </mu-row>
    </div>

    <button type="submit" style="display: none"></button>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>
    <mu-raised-button
      @click.native="submitForm()"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>



import WeightApi from '../../../../api/Tracking/Weight'

import ScrollerMixin from '../../../../mixins/ScrollerMixin'
import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'


export default {
  mixins: [ScrollerMixin, TrackingEditMixin],
  name: 'weight-edit',
  props: {
    preference: {
      type: String,
      default: 'cm'
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data: function() {
    return {
      isUpdating: false,
      reading: {}
    }
  },
  methods: {
    submitForm: function() {
      let self = this;
      self.$validator.validateAll()
        .then(function (valid) {
          if (valid) {
            let model = {};
            self.isUpdating = true;
            model.date = self.reading.date;
            model.tracking_id = self.reading.tracking_id;
            if (self.preference === 'cm') {
              model.waist_cm = self.reading.waist_cm;
              model.hip_cm = self.reading.hip_cm;
            }
            if (self.preference === 'in') {
              model.waist_in = self.reading.waist_in;
              model.hip_in = self.reading.hip_in;
            }

            WeightApi.updateWaistHipTracking(model)
              .then(function (response) {
                let offset = new Date();
                self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes')
                self.$emit('updateReading', self.reading);
                self.$emit('closeEditPanel');
                self.isUpdating = false;
              })
              .catch(function () {
                self.isUpdating = false;
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// WaistHipEdit.vue?1c3cab08